import { TextField, Typography } from "@mui/material";
import React from "react";
import { colors } from "../theme/theme";

interface ValuedTextBoxProps {
  label: string;
  value: string | number;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
}
const ValuedTextBox: React.FC<ValuedTextBoxProps> = ({
  label,
  value,
  rows,
  multiline = false,
  disabled,
  ...props
}) => {
  return (
    <div className="form-field">
      {label && (
        <Typography
          className="typography-text"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: "12px",
            fontWeight: 400,
            color: colors.primary,
            width: "80%",
          }}
          variant="subtitle2"
        >
          {label}
        </Typography>
      )}
      <TextField
        size="small"
        className="text-field"
        sx={{ marginBottom: "0px", marginTop: "8px" }}
        margin="normal"
        value={value}
        multiline={multiline}
        rows={rows}
        disabled={disabled}
        inputProps={{
          style: {
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
          },
        }}
        {...props}
      />
    </div>
  );
};
export default ValuedTextBox;
